module.exports = __webpack_public_path__ + "img/9.7ccb4194.jpg";